import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import fb from "./images/socialLink/logo_fb.png";
import yb from "./images/socialLink/logo_yb.png";
import weibo from "./images/socialLink/logo_weibo.png";
import youku from "./images/socialLink/logo_youku.png";

class SocialLink extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        line: PropTypes.string,
        value: PropTypes.string
      })
    )
  };
  static defaultProps = {
    items: [
      {
        icon: fb,
        link: "https://www.facebook.com/BanyanTreeGroupProperty",
        value: "facebook"
      },
      {
        icon: yb,
        link: "https://www.youtube.com/channel/UChnfjiLt9Qd1e5DPP0UfymA/videos",
        value: "youtube"
      },
      {
        icon: weibo,
        link:
          "https://www.weibo.com/p/1006062680069283/home?from=page_100606&mod=TAB#place",
        value: "weibo"
      },
      {
        icon: youku,
        link: "http://i.youku.com/i/UMTgyNTkxNzYyOA==",
        value: "youku"
      }
    ]
  };
  render() {
    const { items } = this.props;
    return (
      <div className="social-link">
        {_.map(items, (item, key) => {
          return (
            <a href={item.link} key={item.value}>
              <img src={item.icon} alt="icon" />
            </a>
          );
        })}
      </div>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// ./src/components/SocialLink.js